export const INSTALLATION_HELP_URL = "https://getnotion.com/pages/installation-guide-doorbell?utm_medium=App&utm_source=Doorbell_Installation_Help";